import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	searchInputContainer: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		padding: theme.spacing(2)
	},
	searchInput: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		height: "40px",
		borderRadius: "3px",
		"& svg": {
			marginLeft: theme.spacing(1)
		},
		"&::before": {
			borderBottom: "none"
		}
	},
	quickReplyListContent: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		overflowY: "scroll",
		height: "100%",
		maxHeight: "calc(100vh - 128px)",
		paddingTop: 0,
		"& li[data-focus='true']": {
			cursor: "pointer"
		}
	},
	quickReplyItem: {
		paddingBottom: theme.spacing(2),
		outline: "none"
	},
	shortcutNameText: {
		color: colors.gray[700],
		fontWeight: "bold"
	},
	quickReplyItemContainer: {
		pointerEvents: "none"
	}
}))

export default useStyles
